<c11n-modal-dialog #inheritanceDeactivateModal modalId="inheritanceDeactivate" [headingText]="content.header">
  <div c11n-modal-dialog-body>
    <p class="c11n-text-md" [innerHTML]="content.content"></p>

    <div class="c11n-modal-dialog__content__buttons">
      <c11n-button [labelText]="content.startOver" (clickEvent)='startOver()' variant="secondary"></c11n-button>
      <c11n-button [labelText]="content.continue" (clickEvent)='closeModal()'></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
